import {
  DatePicker,
  Drawer,
  FileItem,
  ImageGallery,
  Input,
  Loading,
  Video,
} from "@/components";
import { useMarkAsRead } from "@/hooks";
import { MyNotiStatus, NOTIFICATION_QUERY_KEYS } from "@/types";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { useGetMyNotificationDetail } from "../hooks";

interface Props {
  open: boolean;
  onClose(): void;
  notificationId: number;
}

const DetailMyNotificationDrawer = ({
  open,
  onClose,
  notificationId,
}: Props) => {
  const { notification, isLoading, images, videos, documents } =
    useGetMyNotificationDetail(notificationId);

  const _notification = notification?.notification;
  const createdAt = notification?.created_at;

  // Call read api here if needed
  const { markAsRead } = useMarkAsRead();

  const queryClient = useQueryClient();

  // reset list table
  const resetListTable = () => {
    queryClient.invalidateQueries({
      queryKey: [NOTIFICATION_QUERY_KEYS.GET_MY_NOTIFICATION_BY_PAGES],
    });
  };

  useEffect(() => {
    if (notification && notification.status !== MyNotiStatus.READ) {
      markAsRead([notification.notification_id]).then(() => {
        // reset list table
        resetListTable();
      });
    }
  }, [notification]);

  if (isLoading) return <Loading />;

  return (
    <Drawer
      open={open}
      onClose={onClose}
      label="通知詳細"
      description="テーマ、内容及び添付ファイルをご確認ください。"
    >
      <div className="p-4 space-y-4 flex flex-col h-full overflow-y-auto">
        <DatePicker
          label="通知日"
          value={new Date(createdAt || "")}
          disabled
          dateFormat="yyyy/MM/dd HH:mm"
        />

        <Input label="通知者" value={_notification?.manager} disabled />

        <Input label="通知テーマ" value={_notification?.title} disabled />

        <Input
          label="内容"
          value={_notification?.description}
          disabled
          multiline
        />

        {!!(images.length || videos.length || documents.length) && (
          <div className="text-sm font-semibold text-light_primary">
            添付ファイル
          </div>
        )}

        <ImageGallery images={images} />

        {videos.map((video) => (
          <Video
            key={video.id}
            url={video.url}
            className="w-full max-h-[400px] rounded-lg bg-black"
          />
        ))}

        {documents.map((document) => (
          <FileItem
            key={document.id}
            url={document.url}
            name={document.name}
            type={document.type}
          />
        ))}
      </div>
    </Drawer>
  );
};

export default DetailMyNotificationDrawer;
